import {FilterConfigTypeWithPredicate, FilterOption} from '@lib/utils';

// for easier typing
export const constructFilter = <TEntity, TFilterOption extends FilterOption>(
  filter: FilterConfigTypeWithPredicate<TEntity, TFilterOption>,
) => filter;
